<template>
    <v-form ref="formLogin">
        <v-row>
            <v-col cols="12" class="mb-6">
                <v-row align="center" justify="center" class="flex-column">
                    <v-col cols="auto">
                        <v-img max-width="80px" contain src="/images/logo_roxo.png" />
                    </v-col>
                    <v-col cols="auto" class="text-center">
                        <span class="text-h5 font-weight-bold primary--text">Bem-vindo de volta!</span><br>
                        <span class="text-body-2 secondary--text">Faça login para continuar</span>
                    </v-col>
                </v-row>
            </v-col>
            <v-col v-if="error_message" cols="12">
                <v-alert type="error" text dense rounded="xl">
                    {{ error_message }}
                </v-alert>
            </v-col>
            <v-col cols="12" class="pb-0">
                <span class="text-caption secondary--text font-weight-bold ml-1">Email</span>
                <v-text-field
                    v-model="email"
                    placeholder="seu@email.com"
                    :disabled="loading"
                    :rules="email_rules"
                    color="primary"
                    background-color="background"
                    filled
                    rounded
                    dense
                    height="48"
                    class="mt-1"
                    @keyup.enter="login"
                />
            </v-col>
            <v-col cols="12" class="pt-0">
                <span class="text-caption secondary--text font-weight-bold ml-1">Senha</span>
                <v-text-field
                    v-model="password"
                    placeholder="********"
                    :disabled="loading"
                    :rules="password_rules"
                    type="password"
                    color="primary"
                    background-color="background"
                    filled
                    rounded
                    dense
                    height="48"
                    class="mt-1"
                    @keyup.enter="login"
                />
                <div class="text-right mt-n2">
                    <a class="text-caption primary--text font-weight-bold" @click="$emit('change-view', 'RecoveryForm')">Esqueceu a senha?</a>
                </div>
            </v-col>
            <v-col cols="12" class="mt-4">
                <v-btn 
                    color="primary" 
                    block 
                    large 
                    elevation="0" 
                    class="white--text text-capitalize rounded-xl" 
                    :loading="loading" 
                    :disabled="loading" 
                    @click="login"
                    height="48"
                >
                    Entrar
                </v-btn>
            </v-col>
            <v-col cols="12" class="text-center mt-2">
                <span class="text-body-2 secondary--text">Não possui conta? </span>
                <a class="text-body-2 primary--text font-weight-bold" @click="$emit('change-view', 'RegisterForm')">Crie sua conta</a>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { mapActions } from "vuex";
import * as types from "../store/mutations-types";

export default {
    data() {
        return {
            email: null,
            password: null,
            loading: false,
            email_rules: [
                v => !!v || "Digite um email",
                v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || "Digite um email válido"
            ],
            password_rules: [
                v => !!v || "Digite uma senha"
            ],
            error_message: null
        };
    },
    mounted() {
        this.$store.commit("auth/" + types.SET_TOKEN, null);
        this.$store.commit("auth/" + types.SET_USER, null);
    },
    methods: {
        ...mapActions("auth", ["ActionDoLogin"]),
        async login() {
            this.loading = true;

            if (this.$refs.formLogin.validate()) {
                this.error_message = null;

                try {
                    await this.ActionDoLogin({ email: this.email, password: this.password }).then(response => {
                        if (response.error === "") {
                            this.$router.push({name: "schedule"});
                            this.loading = false;
                        } else {
                            this.loading = false;
                            this.error_message = response.error;
                        }
                    }).catch(error => {
                        this.loading = false;

                        if (error?.response?.data?.error) {
                            this.error_message = error.response.data.error;
                        } else {
                            this.error_message = error.message;
                        }
                    });
                } catch (error) {
                    this.loading = false;
                    this.error_message = error.response.data.error;
                }
            } else {
                this.loading = false;
            }
        }
    }
};
</script>
